import pagination from '../../utils/pagination'
import {
  STORAGE_LOCATIONS_BATCH_DELETE_REQUEST, STORAGE_LOCATIONS_BATCH_DELETE_SUCCESS, STORAGE_LOCATIONS_BATCH_DELETE_FAILURE,
  STORAGE_LOCATIONS_FETCH_MANY_REQUEST, STORAGE_LOCATIONS_FETCH_MANY_SUCCESS, STORAGE_LOCATIONS_FETCH_MANY_FAILURE,
  STORAGE_LOCATIONS_FETCH_REQUEST, STORAGE_LOCATIONS_FETCH_SUCCESS, STORAGE_LOCATIONS_FETCH_FAILURE,
  STORAGE_LOCATIONS_SAVE_REQUEST, STORAGE_LOCATIONS_SAVE_SUCCESS, STORAGE_LOCATIONS_SAVE_FAILURE,

  EMPTY_STORAGE_LOCATIONS,
  CLEAR_ERRORS
} from './types'

export default {
  [STORAGE_LOCATIONS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [STORAGE_LOCATIONS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [STORAGE_LOCATIONS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [STORAGE_LOCATIONS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [STORAGE_LOCATIONS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [STORAGE_LOCATIONS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [STORAGE_LOCATIONS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [STORAGE_LOCATIONS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [STORAGE_LOCATIONS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [STORAGE_LOCATIONS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [STORAGE_LOCATIONS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [STORAGE_LOCATIONS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_STORAGE_LOCATIONS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
